import { useEffect } from 'react'
import { Outlet, useLoaderData, useSubmit } from 'react-router-dom';
import { hasAuthToken, getAuthTokenDuration } from '../util/auth.jsx'

import SiteNavigation from '../components/SiteNavigation';
import InfoNavigation from '../components/InfoNavigation';

function MainLayout() {
  const token = useLoaderData();
  const submit = useSubmit();
  useEffect(() => {
    if (!token) {
      return;
    }

    if (!hasAuthToken()) {
      submit(null, {action: '/logout', method: 'post'})
      return;
    }

    const tokenDuration = getAuthTokenDuration();

    setTimeout(() => {
      submit(null, {action: '/logout', method: 'post'})
    }, tokenDuration); // Use token's duration
  }, [token, submit]);

  return (
    <>
      <SiteNavigation />
      <main className="main">
        <Outlet />
      </main>
      <InfoNavigation />
    </>
  );
}

export default MainLayout;
